import React, { useState, lazy, Suspense } from "react";
import { Grid, CardActionArea, Dialog, Button } from "@mui/material";
import Check from "../../../auth/ability";
import { CAN, SUBJECTS } from "../../../auth/permissions";
import { grey } from "@mui/material/colors";
import DottedTile from "../../common/DottedTile";
import SpokeIcon from "@mui/icons-material/Spoke";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import AddIcon from '@mui/icons-material/Add';
import DescriptionIcon from '@mui/icons-material/Description';
import { CreateVehicleGroupCSVSkeleton, CreateVehicleGroupSkeleton } from "../../common/DialogSkeleton";
const CreateVehicleGroup = lazy(() => import("./CreateVehicleGroup"));
const CreateVehicleGroupFromCsv = lazy(() => import("./CreateVehicleGroupFromCsv"));

const CreateVehicleGroupButton = () => {
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  const [openModalCsv, setOpenModalCsv] = useState(false);
  const handleOpenCsv = () => setOpenModalCsv(true);

  return (
    <>
      <Check I={CAN.CREATE} a={SUBJECTS.GROUP}>
        <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2 }} >
          <CardActionArea onClick={handleOpen}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              sx={{ width: "100%", borderRadius: '6px' }}
            >
              Create a Group
            </Button>
          </CardActionArea>
        </Grid>
        <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2 }} >
          <CardActionArea onClick={handleOpenCsv}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<DescriptionIcon />}
              sx={{ width: "100%", borderRadius: '6px' }}
            >
              Create a Group CSV
            </Button>
          </CardActionArea>
        </Grid>
      </Check>
      {openModal && (
        <Dialog
          open={openModal}
          maxWidth={'lg'}
          onClose={() => setOpenModal(!openModal)}
          PaperProps={{
            sx: {
              height: "calc(100vh - 30px)",
            },
          }}
        >
          <Suspense fallback={<CreateVehicleGroupSkeleton />}>
            <CreateVehicleGroup
              open={openModal}
              toggleDialog={() => setOpenModal(!openModal)}
            />
          </Suspense>
        </Dialog >
      )}
      {
        openModalCsv && (
          <Dialog
            open={openModalCsv}
            maxWidth={'lg'}
            onClose={() => setOpenModalCsv(!openModalCsv)}
            PaperProps={{
              sx: {
                height: "calc(100vh - 30px)",
                width: '100%'
              },
            }}
          >
            <Suspense fallback={<CreateVehicleGroupCSVSkeleton />}>
              <CreateVehicleGroupFromCsv
                open={openModalCsv}
                toggleDialog={() => setOpenModalCsv(!openModalCsv)}
              />
            </Suspense>
          </Dialog>
        )
      }
    </>
  );
};

export default CreateVehicleGroupButton;
